import { userTier } from '../../../../../apollo/cache';
import { UserTiers } from '../../../../../constants/userTiers';
import GET_ORG_INFO from '../../../../shared/queries/getOrgInfoQuery';
import { isUserAdminTier } from '../../../../shared/services/checkUserTierService';
import { PAGE_MODE } from '../../../constants/pageModeTypes';
import { useQuery, useReactiveVar } from '@apollo/client';

const usePageMode = orgId => {
  const currentUserTier = useReactiveVar(userTier);

  const { data: orgInfo } = useQuery(GET_ORG_INFO, {
    variables: { id: orgId }
  });

  const pageMode =
    orgInfo &&
    orgInfo.mddapOrganization &&
    getPageMode(currentUserTier, orgInfo.mddapOrganization.SystemName);

  return pageMode;
};

export default usePageMode;

const getPageMode = (userTier, systemName) => {
  if (systemName) {
    return pageModeSystemNameMap.get(systemName);
  }

  if (!isUserAdminTier(userTier)) {
    if (userTier === UserTiers.Org) {
      return PAGE_MODE.MddapOrg;
    }

    if (userTier === UserTiers.OrgUnit) {
      return PAGE_MODE.OrgUnit;
    }
  }

  return PAGE_MODE.MddapOrg;
};

const pageModeSystemNameMap = new Map([
  ['ISACA', PAGE_MODE.ISACAVipOrg],
  ['FDA', PAGE_MODE.FDAVipOrg],
  ['MDIC', PAGE_MODE.MDICVipOrg]
]);
